module.exports = __webpack_public_path__ + "static/pic04-26755b497ba64cd120ef1c2a645998db.png";